module.exports = __webpack_public_path__ + "img/ico_external_link.d20908e1.svg";